<template>
    <CorePagination
        :pagination="pagination"
        :additionalAnalyticsData="additionalAnalyticsData"
        @click="handlePaginationUpdate"
    />
</template>

<script>
import { get } from 'lodash-es';

import { handlePaginationUrlUpdate } from '~coreModules/core/js/url-utils';

import CorePagination from '~coreModules/core/components/ui/CorePagination.vue';

export default {
    name: 'PaginationElement',
    components: {
        CorePagination,
    },
    props: {
        pagination: {
            type: Object,
            required: true,
        },
        catalogContext: {
            type: String,
            default: '',
        },
    },
    computed: {
        additionalAnalyticsData() {
            return {
                catalogResponseId: get(this.$store.state, `${this.catalogContext}.catalog.responseId`),
            };
        },
    },
    methods: {
        handlePaginationUpdate(nextPage) {
            handlePaginationUrlUpdate(nextPage, this.$route, this.$router);
        },
    },
};
</script>
